export const services = [
  {
    id: 1,
    title: "Electrical Contracting",
    description: "Residential, Commercial & Industrial Electrical Works with safety, quality and timely execution.",
    icon: "Zap",
    image: "https://images.unsplash.com/photo-1621905251918-48416bd8575a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxlbGVjdHJpY2lhbiUyMHBhbmVsfGVufDB8fHx8MTc4NDgxNjU2MHww&ixlib=rb-4.1.0&q=85",
    iconBg: "#1e3a8a"
  },
  {
    id: 2,
    title: "Solar Installation",
    description: "On-grid, Off-grid & Rooftop Solar Solutions for homes, businesses and agricultural needs.",
    icon: "SunMedium",
    image: "https://images.unsplash.com/flagged/photo-1566838616631-f2618f74a6a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHw0fHxyb29mdG9wJTIwc29sYXJ8ZW58MHx8fHwxNzg0ODE2NTYwfDA&ixlib=rb-4.1.0&q=85",
    iconBg: "#F5B800"
  },
  {
    id: 3,
    title: "Maintenance",
    description: "Electrical Maintenance, Preventive Maintenance & Troubleshooting with quick response.",
    icon: "Wrench",
    image: "https://images.pexels.com/photos/34054464/pexels-photo-34054464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    iconBg: "#1e3a8a"
  },
  {
    id: 4,
    title: "Panel Installation",
    description: "LT Panels, Distribution Panels, MCC Panels, APFC Panels & more with professional installation.",
    icon: "LayoutPanelTop",
    image: "https://images.pexels.com/photos/28265032/pexels-photo-28265032.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    iconBg: "#F5B800"
  }
];

export const stats = [
  { id: 1, value: "100+", label: "Happy Clients", icon: "Users" },
  { id: 2, value: "150+", label: "Solar Installations", icon: "SunMedium" },
  { id: 3, value: "50+", label: "Transformer Projects", icon: "Zap" },
  { id: 4, value: "5+", label: "Years of Experience", icon: "Award" }
];

export const whyChooseUs = [
  { id: 1, title: "Quality Workmanship", description: "We never compromise on quality.", icon: "BadgeCheck" },
  { id: 2, title: "Safety First", description: "We follow strict safety standards.", icon: "ShieldCheck" },
  { id: 3, title: "On-Time Delivery", description: "Projects completed within timeline.", icon: "Clock" },
  { id: 4, title: "Affordable Pricing", description: "Best solutions at competitive rates.", icon: "IndianRupee" }
];

export const aboutFeatures = [
  "Experienced & Skilled Team",
  "Quality Materials",
  "Timely Completion",
  "Customer Satisfaction"
];

export const projects = [
  {
    id: 1,
    title: "Rooftop Solar Installation",
    subtitle: "10kW On-Grid System",
    image: "https://images.unsplash.com/flagged/photo-1566838616631-f2618f74a6a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHw0fHxyb29mdG9wJTIwc29sYXJ8ZW58MHx8fHwxNzg0ODE2NTYwfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Transformer Installation",
    subtitle: "100kVA Transformer",
    image: "https://images.unsplash.com/photo-1509390144018-eeaf65052242?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxwb3dlciUyMHRyYW5zZm9ybWVyfGVufDB8fHx8MTc4NDgxNjU2MHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "LT Panel Installation",
    subtitle: "MCC Panel",
    image: "https://images.pexels.com/photos/28265032/pexels-photo-28265032.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 4,
    title: "Solar Pump Installation",
    subtitle: "7.5HP Solar Pump",
    image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_visual-website-13/artifacts/kkeyj851_images.jfif"
  },
  {
    id: 5,
    title: "Industrial Wiring",
    subtitle: "Factory Setup",
    image: "https://images.unsplash.com/photo-1621905251918-48416bd8575a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxlbGVjdHJpY2lhbiUyMHBhbmVsfGVufDB8fHx8MTc4NDgxNjU2MHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 6,
    title: "Substation Maintenance",
    subtitle: "33/11 kV Substation",
    image: "https://images.pexels.com/photos/34054464/pexels-photo-34054464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  }
];

export const heroImage = "https://images.unsplash.com/photo-1629726797843-618688139f5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxzb2xhciUyMHBhbmVscyUyMHN1YnN0YXRpb258ZW58MHx8fHwxNzg0ODE2NTYwfDA&ixlib=rb-4.1.0&q=85";

export const aboutImage = "https://images.unsplash.com/photo-1509390144018-eeaf65052242?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxwb3dlciUyMHRyYW5zZm9ybWVyfGVufDB8fHx8MTc4NDgxNjU2MHww&ixlib=rb-4.1.0&q=85";

export const companyInfo = {
  name: "Brahma Electrical",
  tagline: "Powering Your Future",
  phone: "+91 84595 04043",
  email: "brahmaelectricalsolarsolutions@gmail.com",
  address: "Sillod, Chhatrapati Sambhajinagar, Maharashtra - 431112",
  whatsapp: "918459504043"
};
